import React from 'react';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";

import "./styles/Main.scss";
import Index from "./pages/Index";
import Unlock from "./pages/Unlock";
import Header from "./fragments/Header";
import Footer from "./fragments/Footer";

export default function App() {
    return (
        <Router>
            <Header/>
            <div>
                <Switch>
                    <Route path="/" exact render={(props) => <Index {...props}/>}/>
                    <Route path={["/unlock", "/unlock/:token"]} exact render={(props) => <Unlock {...props}/>}/>
                </Switch>
            </div>
            <Footer/>
        </Router>
    );
}